import { render } from "./main-header.vue?vue&type=template&id=11ffb480"
import script from "./main-header.vue?vue&type=script&lang=js"
export * from "./main-header.vue?vue&type=script&lang=js"

import "./main-header.vue?vue&type=style&index=0&id=11ffb480&lang=less"

import exportComponent from "/Users/jiaxibei/Desktop/bilibiliProjects/ProfessProject/campus-activity-toc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__